import { render, staticRenderFns } from "./avatarComponent.vue?vue&type=template&id=14fa2755&scoped=true"
import script from "./avatarComponent.vue?vue&type=script&lang=js"
export * from "./avatarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa2755",
  null
  
)

export default component.exports